import React, { ReactElement } from "react";
import MainImg from "./mainImg";

import SharedButton from "../sharedButton";
export default function CarWarrantyCover(): ReactElement {
    return (
        <section className="flex flex-col lg:flex-row lg:gap-28 gap-16  lg:mt-28 mt-14 lg:mb-52 mb-28 ">
            <div className="max-w-[574px]  mx-auto lg:mx-0 ">
                <h2 className="font-bold lg:text-3xl text-2xl lg:leading-[45px] ">
                    What Does a Car Warranty Cover?
                </h2>
                <p className="mt-5   lg:text-lg text-base lg:leading-8  font-light">
                    An auto warranty covers repairs for parts that fail due to
                    defects or errors in how your vehicle was built. So, if your
                    power window motor, transmission or infotainment system
                    stops working as it's supposed to, you can take it back to
                    the dealership, and they'll fix it. There will typically be
                    no deductible with a new car warranty, and getting coverage
                    will be a no-haggle affair. Warranties will typically cover
                    both the failed part and the labor to swap it out or repair
                    it. Car warranties last for a certain number of miles or
                    years and expire when you hit the first milestone. For
                    example, if your auto warranty is for five years or 50,000
                    miles, it would end once your mileage hits 50,000 even if
                    the car was only three years old. It would expire after five
                    years even if you only have driven 30,000 miles.
                </p>
                <div className="lg:mt-[50px] mt-7 text-center sm:text-left">
                    <SharedButton />
                </div>
                <span className="w-[122px] h-[8px] lg:block bg-[#F02B17] mt-9 hidden"></span>
            </div>
            <div className="w-[300px] h-[250px] md:h-[400px] md:w-[525px] md:min-w-[525px] relative mx-auto lg:mx-0 lg:mt-12">
                <MainImg />
            </div>
        </section>
    );
}
